export default __webpack_public_path__ + "static/media/Auth.cd9b7621.svg";